import { ITreeviewLopFocusedValue } from "../../../components-data/treeview-lop/TreeviewLop";
import { IHocPhanMienInsertsRequest } from "../../../model/request/diem/hoc-phan-mien/IHocPhanMienInsertsRequest";
import { IHoSoSinhVienViewModel } from "../../../model/response/category/IHoSoSinhVienViewModel";
import { IHocPhanMienViewModel } from "../../../model/response/diem/hoc-phan-mien/IHocPhanMienViewModel";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eHocPhanMienActionsObj = {
    CHANGE_FOCUSED_VALUE_LOP: {} as ITreeviewLopFocusedValue,

    LOAD_START: {} as number[],
    LOAD_SUCCESS: {} as IHocPhanMienViewModel[],
    LOAD_ERROR: "",

    INSERTS_START: {} as IHocPhanMienInsertsRequest,
    INSERTS_SUCCESS: undefined,
    INSERTS_ERROR: "",

    DELETES_START: {} as number[],
    DELETES_SUCCESS: undefined,
    DELETES_ERROR: "",

    LOAD_HO_SO_SINH_VIEN_START: {} as number[],
    LOAD_HO_SO_SINH_VIEN_SUCCESS: {} as IHoSoSinhVienViewModel[],
    LOAD_HO_SO_SINH_VIEN_ERROR: "",
    
    SINH_VIEN_SELECTED_IDS_CHANGE: {} as number[],
    
    MON_MIEN_SELECTED_IDS_CHANGE: {} as number[],

    SHOW_THEM_HOC_PHAN_MIEN_MODAL:  {} as number[],
    CLOSE_THEM_HOC_PHAN_MIEN_MODAL: undefined,
}

export const eHocPhanMienActionIds = generateActionTypeIds(eHocPhanMienActionsObj, "HOC_PHAN_MIEN");
export type IHocPhanMienActionTypes = IGenericActionType<typeof eHocPhanMienActionsObj, "HOC_PHAN_MIEN">;